// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K8I2","field":"styles_field__11iZN","fieldCol":"styles_fieldCol__1UjtF","diffCol":"styles_diffCol__LDP5o","diff":"styles_diff__2CYRp"};